import { createAction } from './createAction';
import { createForecast } from './createForecast';
import { createSuggestion } from './createSuggestion';
import { deleteAction } from './deleteAction';
import { deleteSuggestion } from './deleteSuggestion';
import { forecastWeek } from './forecastWeek';
import { getActions } from './getActions';
import { getAggregatedActivities } from './getAggregatedActivities';
import { getCalculatedInternals } from './getCalculatedInternals';
import { getEmployeeHours } from './getEmployeeHours';
import { getFiles } from './getFiles';
import { getImprovementAreas } from './getImprovementAreas';
import { getPredictions } from './getPredictions';
import { getSuggestions } from './getSuggestions';
import { getTenant } from './getTenant';
import { rejectSuggestion } from './rejectSuggestion';
import { updateAction } from './updateAction';
import { uploadFile } from './uploadFile';
export * as oidcAPI from './OIDC/api';

const api = {
  createAction,
  createForecast,
  createSuggestion,
  deleteAction,
  deleteSuggestion,
  forecastWeek,
  getActions,
  getAggregatedActivities,
  getCalculatedInternals,
  getEmployeeHours,
  getFiles,
  getImprovementAreas,
  getPredictions,
  getSuggestions,
  getTenant,
  rejectSuggestion,
  updateAction,
  uploadFile,
};
export { api };
